export default "__VITE_ASSET__BvFZnxeQ__"